import { render, staticRenderFns } from "./WatchlistShare.vue?vue&type=template&id=26410ae5&scoped=true&"
import script from "./WatchlistShare.vue?vue&type=script&lang=js&"
export * from "./WatchlistShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26410ae5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26410ae5')) {
      api.createRecord('26410ae5', component.options)
    } else {
      api.reload('26410ae5', component.options)
    }
    module.hot.accept("./WatchlistShare.vue?vue&type=template&id=26410ae5&scoped=true&", function () {
      api.rerender('26410ae5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/dialog/WatchlistShare.vue"
export default component.exports